var React = require('react');

function SpeakerOff (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M29.5625 21.5C29.5625 18.3287 27.735 15.6054 25.0833 14.2796V18.2392L29.4729 22.6287C29.5267 22.2704 29.5625 21.8942 29.5625 21.5V21.5ZM34.0417 21.5C34.0417 23.1842 33.6833 24.7608 33.0742 26.23L35.7796 28.9354C36.9621 26.7137 37.625 24.1875 37.625 21.5C37.625 13.8317 32.2679 7.4175 25.0833 5.78708V9.47792C30.2612 11.0187 34.0417 15.8204 34.0417 21.5ZM7.65042 5.375L5.375 7.65042L13.8496 16.125H5.375V26.875H12.5417L21.5 35.8333V23.7754L29.1146 31.39C27.9142 32.3217 26.5704 33.0563 25.0833 33.5042V37.195C27.5558 36.6396 29.7954 35.4929 31.6946 33.9521L35.3496 37.625L37.625 35.3496L21.5 19.2246L7.65042 5.375ZM21.5 7.16667L17.7554 10.9113L21.5 14.6558V7.16667Z","fill":"white"}));
}

SpeakerOff.defaultProps = {"viewBox":"0 0 43 43","fill":"none"};

module.exports = SpeakerOff;

SpeakerOff.default = SpeakerOff;
